"use strict";
import Tuple from "./tuple";
import Effects from "./effects";
import { List } from "immutable";
import fjs from "functional.js";
const child = (modelOrModelAndEffects, keyOrKeyPath, componentUpdate, componentAction) => {
  const [model, effects] = modelAndEffects(modelOrModelAndEffects);
  const keyPath = fjs.isArray(keyOrKeyPath) ? keyOrKeyPath : [keyOrKeyPath];
  const [childModel, newEffects] = componentUpdate(model.getIn(keyPath));
  const newModel = model.setIn(keyPath, childModel);
  const mappedEffects = Effects.map(componentAction, newEffects);
  return Tuple(newModel, effects.concat(mappedEffects));
};
const children = (modelOrModelAndEffects, keyOrKeyPath, componentUpdate, componentAction) => {
  const [model, effects] = modelAndEffects(modelOrModelAndEffects);
  const keyPath = fjs.isArray(keyOrKeyPath) ? keyOrKeyPath : [keyOrKeyPath];
  const [childModels, newEffects] = model.getIn(keyPath).map((m) => componentUpdate(m)).reduce(([models, allEffects], [model2, effects2]) => Tuple(
    models.push(model2),
    allEffects.concat(effects2)
  ), Tuple(List(), List()));
  const newModel = model.setIn(keyPath, childModels);
  const mappedEffects = Effects.map(componentAction, newEffects);
  return Tuple(newModel, effects.concat(mappedEffects));
};
const updateModel = (modelOrModelAndEffects, modelUpdate) => {
  const [model, effects] = modelAndEffects(modelOrModelAndEffects);
  const [newModel, newEffects] = modelUpdate(model);
  return Tuple(newModel, effects.concat(newEffects));
};
const chain = (modelOrModelAndEffects) => {
  return {
    child: chainChild(modelOrModelAndEffects),
    model: chainModel(modelOrModelAndEffects),
    value: chainValue(modelOrModelAndEffects)
  };
};
const chainChild = fjs.curry(
  (modelOrModelAndEffects, keyOrKeyPath, componentUpdate, componentAction) => {
    return chain(child(
      modelOrModelAndEffects,
      keyOrKeyPath,
      componentUpdate,
      componentAction
    ));
  }
);
const chainModel = fjs.curry((modelOrModelAndEffects, modelUpdate) => chain(updateModel(modelOrModelAndEffects, modelUpdate)));
const chainValue = (modelOrModelAndEffects) => () => modelOrModelAndEffects;
const modelAndEffects = (modelOrModelAndEffects) => {
  const isModel = !modelOrModelAndEffects.isTuple;
  if (isModel) {
    return List.of(modelOrModelAndEffects, Effects.none);
  } else {
    return modelOrModelAndEffects;
  }
};
export default {
  chain,
  child,
  children,
  model: updateModel
};
